import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-denuncias',
  templateUrl: './main-denuncias.component.html',
  styleUrls: ['./main-denuncias.component.css']
})
export class MainDenunciasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
